module.exports = __webpack_public_path__ + "static/media/ThumbsUp-Icon.4e65bc44.svg";